<mat-icon matTooltip="Warning" class="warning">warning</mat-icon>
